module.exports = __webpack_public_path__ + "media/images/vp/icon.hours.gray-2722ec01b12f5abf8148c3a8ac2b5d3e.png";